export const SmallText = ({ children }: { children: React.ReactNode }) => {
    return <span className="fs-7 text-wrap text-break">{children}</span>;
};
